export default __webpack_public_path__ + "static/media/front_page_1.a0236744.jpg";